<template lang="pug">
#modal-header-rastreabilidade-relatorio-em-massa-planilha
    el-dialog.modal-header-rastreabilidade-relatorio-em-massa-planilha-content(
        :visible.sync='show',
        :close-on-click-modal='false',
        :close-on-press-escape='false',
        :destroy-on-close='true',
        :show-close='false',
        width='50%'
    )
        span(slot='title')
            h3
                b {{ $t('mensagens.relatorioRastreabilidade.cadastro.informarRastreabilidadeMassa') }}

        .modal-header-planilha-content__container
            .container-header
                .modal-header-planilha-content__container__infor
                    span {{ $t('mensagens.relatorioRastreabilidade.cadastro.avisoAnalisePlanilha') }} <br>{{ $t('mensagens.relatorioRastreabilidade.cadastro.avisoCamposObrigatorios') }}

                .modal-header-planilha-content__container__infor__lista
                    ul
                        li {{ $t('mensagens.comuns.car') }}
                        li {{ $t('mensagens.relatorioRastreabilidade.cadastro.volume').toUpperCase() }}
                        li {{ $t('mensagens.comuns.cpfCnpj') }}
                        li {{ $t('mensagens.relatorioRastreabilidade.cadastro.ciclo').toUpperCase() }}/{{ $t('mensagens.relatorioRastreabilidade.cadastro.ano').toUpperCase() }}

                .modal-header-planilha-content__container__infor__campos
                    p {{ $t('mensagens.relatorioRastreabilidade.cadastro.vincularCampos') }}
                    .modal-header-planilha-content__container__infor__campos__vincular
                        .header
                            span.header-planilha {{ $t('mensagens.relatorioRastreabilidade.cadastro.camposImportadosPlanilha') }}
                            span.header-rastreabilidade {{ $t('mensagens.relatorioRastreabilidade.cadastro.camposRastreabilidade') }}

                        .campos(
                            v-for='(cabecalho, index) in dados',
                            :key='index',
                            :class='{ "campo--tracejado": index % 2 === 0 }'
                        )
                            span.campos-planilha {{ cabecalho }}
                            span.campos-rastreabilidade
                                el-select(
                                    v-model='campoRastreabilidadeObrigatorio[cabecalho]',
                                    placeholder='Selecione',
                                    clearable,
                                    :disabled='carregando'
                                )
                                    el-option(
                                        v-for='campo in camposRastreabilidade',
                                        :key='campo.codigo',
                                        :label='campo.translatedName',
                                        :value='campo.nome',
                                        :disabled='campoRastreabilidadeJaSelecionado(campo.nome)'
                                    )

        footer.footer-modal-header.my-3(slot='footer')
            el-button(@click='fecharModal', :disabled='carregando')
                | {{ $t('mensagens.comuns.voltar') }}
            div(v-if='!verificarSelecao')
                el-tooltip(
                    effect='dark',
                    :content='$t("mensagens.relatorioRastreabilidade.cadastro.relacioneCamposAntesInformar")',
                    placement='top'
                )
                    el-button(type='primary')
                        | {{ $t('mensagens.relatorioRastreabilidade.cadastro.processarVinculo') }}
            div(v-else)
                el-button(
                    type='primary',
                    @click='processarVinculo',
                    :loading='carregando',
                    :icon='carregando ? "el-icon-loading" : ""'
                )
                    | {{ carregando ? '' : $t('mensagens.relatorioRastreabilidade.cadastro.processarVinculo') }}
</template>

<script>
export default {
    name: 'ModalHeaderRastreabilidadeRelatorioEmMassaPlanilha',

    props: {
        show: {
            type: Boolean,
            required: true
        },
        dados: {
            type: Array,
            required: true
        },
        carregando: {
            type: Boolean,
            required: false
        }
    },

    data() {
        return {
            camposRastreabilidade: [
                {
                    nome: 'CAR',
                    codigo: 'CAR',
                    translatedName: 'CAR'
                },
                {
                    nome: 'CPF/CNPJ',
                    codigo: 'CPF_CNPJ',
                    translatedName: 'CPF/CNPJ'
                },
                {
                    nome: 'Volume',
                    codigo: 'VOLUME',
                    translatedName: this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.volume'
                    ).toUpperCase()
                },
                {
                    nome: 'CICLO/ANO',
                    codigo: 'CICLO_ANO',
                    translatedName:
                        this.$t(
                            'mensagens.relatorioRastreabilidade.cadastro.ciclo'
                        ).toUpperCase() +
                        '/' +
                        this.$t(
                            'mensagens.relatorioRastreabilidade.cadastro.ano'
                        ).toUpperCase()
                }
            ],
            campoRastreabilidadeObrigatorio: {}
        };
    },

    watch: {
        show: function () {
            if (!this.show) return;
            this.resetModal();
        },
        '$i18n._vm.locale': function () {
            this.camposRastreabilidade.forEach(campo => {
                if (campo.codigo === 'VOLUME') {
                    campo.translatedName = this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.volume'
                    ).toUpperCase();
                }

                if (campo.codigo === 'CICLO_ANO') {
                    campo.translatedName =
                        this.$t(
                            'mensagens.relatorioRastreabilidade.cadastro.ciclo'
                        ).toUpperCase() +
                        '/' +
                        this.$t(
                            'mensagens.relatorioRastreabilidade.cadastro.ano'
                        ).toUpperCase();
                }
            });
        }
    },

    computed: {
        verificarSelecao() {
            return (
                Object.keys(this.campoRastreabilidadeObrigatorio).length ===
                this.camposRastreabilidade.length
            );
        }
    },

    methods: {
        resetModal() {
            this.campoRastreabilidadeObrigatorio = {};
        },

        fecharModal() {
            if (this.carregando) {
                return;
            }
            try {
                this.$messageBox
                    .confirm(
                        this.$t(
                            'mensagens.relatorioRastreabilidade.cadastro.alertaDadosNaoSeraoSalvos'
                        ),
                        this.$t('mensagens.comuns.aviso'),
                        {
                            confirmButtonText: this.$t('mensagens.comuns.sim'),
                            cancelButtonText: this.$t(
                                'mensagens.relatorioRastreabilidade.cadastro.permanecer'
                            ),
                            type: 'warning'
                        }
                    )
                    .then(() => {
                        this.$emit('voltar');
                    })
                    .catch(() => {});
            } catch (erro) {}
        },
        campoRastreabilidadeJaSelecionado(opcao) {
            for (const chave in this.campoRastreabilidadeObrigatorio) {
                if (
                    this.campoRastreabilidadeObrigatorio.hasOwnProperty(chave)
                ) {
                    if (this.campoRastreabilidadeObrigatorio[chave] === '') {
                        delete this.campoRastreabilidadeObrigatorio[chave];
                    } else if (
                        this.campoRastreabilidadeObrigatorio[chave] === opcao
                    ) {
                        return true;
                    }
                }
            }
            return false;
        },
        processarVinculo() {
            if (this.carregando) return;
            this.$emit(
                'processarVinculo',
                this.campoRastreabilidadeObrigatorio
            );
        }
    }
};
</script>

<style lang="scss">
#modal-header-rastreabilidade-relatorio-em-massa-planilha {
    footer {
        display: flex;
        justify-content: space-between;
    }
}
.modal-header-rastreabilidade-relatorio-em-massa-planilha-content {
    .el-dialog__header {
        padding: 20px;
        padding-bottom: 10px;
        background: var(--primary);
        color: var(--white);
        padding-bottom: 12px;
        padding-top: 12px;
    }
    .el-dialog__body {
        padding: 20px 20px 30px 20px;
        word-break: break-word;
    }
    .el-dialog__headerbtn {
        top: 10px;
    }
    .el-dialog__headerbtn:hover .el-icon-close {
        color: #ffffff;
    }
    .modal-analise-elegibilidade--header {
        display: flex;
        align-items: center;
    }

    .modal-header-planilha-content__container {
        .modal-header-planilha-content__container__infor {
            margin-bottom: 8px;
        }
        .modal-header-planilha-content__container__infor__lista {
            ul {
                font-weight: bold;
                font-size: 14px;
                margin-bottom: 10px;
            }
            li::after {
                content: ' *';
                color: #f56c6c;
            }
        }
        .modal-header-planilha-content__container__infor__campos {
            p {
                color: #656565;
                font-weight: bold;
            }
            .modal-header-planilha-content__container__infor__campos__vincular {
                display: flex;
                flex-direction: column;
                width: 100%;
                align-items: center;
                justify-content: space-between;
                box-shadow: 0px 1px 7px 0px var(--block-shadow);
                border-radius: 3px;

                .header {
                    background: #f7f7f7;
                    min-height: 45px;
                    color: #606266;
                    font-weight: bold;
                    border-bottom: 1px solid #d8d8d8;
                }
                .campos {
                    min-height: 33px;
                    &.campo--tracejado {
                        background-color: #f3f3f3;
                    }
                }

                .header,
                .campos {
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                    gap: 5px;
                    align-items: center;
                    padding: 5px;
                    padding-left: 15px;
                }
                .header .header-planilha,
                .header .header-rastreabilidade,
                .campos .campos-planilha,
                .campos .campos-rastreabilidade {
                    width: 50%;
                }
                .campos-rastreabilidade {
                    .el-select {
                        width: 90% !important;
                    }
                }
            }
        }
    }

    .footer-modal-header {
        .el-button {
            min-width: 153px;
        }
    }
}
</style>
